module.exports = __webpack_public_path__ + "static/media/opencart-logo.3b6dcca1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/opencart-logo.svg
// module id = 720
// module chunks = 0